import React from 'react';
import createSvgIcon from '../utils/createSvgIcon';

export default createSvgIcon(React.createElement(
  'g',
  null,
  React.createElement(
    'title',
    null,
    'Trace Icons_1-3'
  ),
  React.createElement('path', { d: 'M15.4 13.7v6.8h1.3v-6.8l2.2 2.2.9-.9-2.8-2.8c-.5-.5-1.4-.5-1.9 0L12.3 15l.9.9 2.2-2.2z' }),
  React.createElement('path', { d: 'M20.8 22.2c0 .1-.2.2-.6.2h-8.4c-.2 0-.4-.1-.6-.2v-1.9H10v1.9c.1.9.9 1.6 1.8 1.5h8.4c.9.1 1.7-.6 1.8-1.5v-1.9h-1.3c.1 0 .1 1.9.1 1.9z' }),
  React.createElement('path', { d: 'M27.1 8.8l-6.1-6c-.1-.1-.3-.2-.4-.2H7.7c-1.6 0-3 1.3-3 2.9v20.6c0 1.6 1.4 2.9 3 2.9h16.6c1.6 0 3-1.3 3-2.9V9.3c0-.2-.1-.4-.2-.5zm-1.2.6h-3.1c-1.2 0-2.2-.9-2.3-2.1V4l5.4 5.4zm-1.6 18.4H7.7c-.9 0-1.7-.7-1.7-1.7V5.5c0-.9.8-1.7 1.7-1.7h11.5v3.5c.1 1.9 1.6 3.4 3.5 3.3H26v15.5c0 1-.8 1.7-1.7 1.7z' })
));